// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/educations",
  Create: "/pyr/employees/{employeeId}/educations",
  Detail: "/pyr/employees/{employeeId}/educations/{id}",
  Update: "/pyr/employees/{employeeId}/educations/{id}",
  Delete: "/pyr/employees/{employeeId}/educations/{id}",
};
